import { render } from "./CompetenceTaskPanel.vue?vue&type=template&id=774826a4"
import script from "./CompetenceTaskPanel.vue?vue&type=script&lang=js"
export * from "./CompetenceTaskPanel.vue?vue&type=script&lang=js"

import "./CompetenceTaskPanel.vue?vue&type=style&index=0&id=774826a4&lang=scss"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__